import { render } from "./GetTlntReportForm.vue?vue&type=template&id=4c4a0857&scoped=true"
import script from "./GetTlntReportForm.vue?vue&type=script&lang=js"
export * from "./GetTlntReportForm.vue?vue&type=script&lang=js"

import "./GetTlntReportForm.vue?vue&type=style&index=0&id=4c4a0857&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4a0857"]])

export default __exports__